import React from 'react';
import { useTranslation } from 'react-i18next';

// Discreet attribution under every guest page: guests who host elsewhere
// discover Velohost here. UTM tags let Plausible attribute the visits.
const PoweredBy: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="page-bg pb-8 pt-2 text-center text-xs text-slate-500">
      <a
        href="https://website.velohost.it/?utm_source=guest-portal&utm_medium=referral&utm_campaign=powered-by"
        target="_blank"
        rel="noopener"
        className="inline-flex min-h-[44px] items-center gap-1 px-3 hover:text-slate-700"
      >
        {t('common.poweredBy')} <span className="font-semibold">Velohost</span>
      </a>
    </footer>
  );
};

export default PoweredBy;
